import { render, staticRenderFns } from "./PsSearch.vue?vue&type=template&id=0ae05b04&scoped=true&"
import script from "./PsSearch.vue?vue&type=script&lang=js&"
export * from "./PsSearch.vue?vue&type=script&lang=js&"
import style0 from "./PsSearch.vue?vue&type=style&index=0&id=0ae05b04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae05b04",
  null
  
)

export default component.exports